module.exports = __webpack_public_path__ + "img/info-icon-gray.471562bb.svg";